import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';
import SpinnerComponent from '../components/SpinnerComponent';
import FormAccettazioneEsercizio from '../components/FormAccettazioneEsercizio';
import { reportError } from '../utils/reportApiError';
import {
  fetchWithRetry,
  isTransportError,
  isLoadBalancerStatus,
  transportErrorMessage,
  ERRORE_GENERICO,
  SERVIZIO_IN_AGGIORNAMENTO,
} from '../utils/api/api';

const styles = (theme) => ({
  mainContainer: {
    textAlign: 'center',
    color: 'black',
    padding: '26px',
  },
});

class AccettaEsercizioCommerciale extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      record: {
        id: null,
        consulenteId: null,
        responsabileSicurezzaId: null,
        nome: null,
        ragioneSociale: null,
        partitaIva: null,
        codiceAteco: null,
        telefono: null,
        nomeGestore: null,
        cognomeGestore: null,
        emailGestore: null,
        telefonoGestore: null,
        indirizzoSede: null,
        numeroSede: null,
        cittaSede: null,
        provinciaSede: null,
        giornoChiusura: '',
        privacyPolicyAccettata: false,
        terminiUsoAccettati: false,
      },
      loading: false,
      notfoundRecord: false,
      saveButtonEnabled: false,
      saveMessageVisible: false,
    };
  }

  componentDidMount() {
    this.mounted = true;
    this.fetchRecord(this.props.activationKey);
  }

  componentWillUnmount() {
    // The retry keeps a request alive for seconds after the operator may have
    // left the page, so what comes back is dropped rather than set on state.
    this.mounted = false;
  }

  fetchRecord = (activationKey) => {
    this.setState({
      loading: true,
    });
    const ENDPOINT = process.env.REACT_APP_BACKEND_ENDPOINT;
    const url =
      ENDPOINT + '/api/esercizi_commerciali/attivazione/' + activationKey;
    fetchWithRetry(url, {
      method: 'GET',
    })
      .then((response) => {
        const status = response.status;
        if (status === 200) {
          return response.json();
        }
        // The status is what the catch below maps to a sentence: a `Response`
        // carries no `message`, so throwing that left the dialog empty.
        throw new Error('' + status);
      })
      .then((result) => {
        if (!this.mounted) {
          return;
        }
        if (result.giornoChiusura === null) {
          result.giornoChiusura = '';
        }
        this.setState({
          loading: false,
          record: result,
        });
      })
      .catch((error) => {
        if (!this.mounted) {
          return;
        }
        let title = '';
        let msg = ERRORE_GENERICO;
        if (error.message === '404') {
          title = 'Attenzione';
          msg = 'Registrazione già confermata.';
        } else if (isTransportError(error)) {
          msg = transportErrorMessage();
        } else if (isLoadBalancerStatus(Number(error.message))) {
          msg = SERVIZIO_IN_AGGIORNAMENTO;
        }
        this.setState({ loading: false, notfoundRecord: true });
        reportError(msg, title);
      });
  };

  handleSubmit = (event) => {
    event.preventDefault();
    this.setState({
      loading: true,
    });
    const ENDPOINT = process.env.REACT_APP_BACKEND_ENDPOINT;
    const url =
      ENDPOINT +
      '/api/esercizi_commerciali/attivazione/' +
      this.props.activationKey;
    fetchWithRetry(url, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((response) => {
        let status = response.status;
        if (status === 200) {
          return response.json();
        }
        throw new Error('' + status);
      })
      .then((result) => {
        if (!this.mounted) {
          return;
        }
        this.setState({
          loading: false,
          saveButtonEnabled: false,
          saveMessageVisible: true,
        });
      })
      .catch((error) => {
        if (!this.mounted) {
          return;
        }
        let msg = ERRORE_GENERICO;
        if (error.message === '404') {
          msg = 'Codice di attivazione non trovato.';
        } else if (error.message === '401') {
          msg = 'Si è verificato un errore.';
        } else if (isTransportError(error)) {
          msg = transportErrorMessage();
        } else if (isLoadBalancerStatus(Number(error.message))) {
          msg = SERVIZIO_IN_AGGIORNAMENTO;
        }
        this.setState({ loading: false, notfoundRecord: true });
        reportError(msg);
      });
  };

  handleCheck = () => {
    this.setState((prevState) => {
      const updatedRecord = {
        ...prevState.record,
        privacyPolicyAccettata: !prevState.record.privacyPolicyAccettata,
        terminiUsoAccettati: !prevState.record.terminiUsoAccettati,
      };
      return { record: updatedRecord };
    });
  };

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.mainContainer}>
        <Typography variant="h4">
          Conferma registrazione esercizio commerciale
        </Typography>
        <Grid
          container
          justify="center"
          style={{ marginTop: '26px', marginBottom: '26px' }}
        >
          <div style={{ width: '700px', minHeight: '700px' }}>
            {this.state.loading ? (
              <SpinnerComponent size={32} />
            ) : (
              !this.state.notfoundRecord && (
                <div>
                  {this.state.saveMessageVisible ? (
                    <Typography
                      variant="h6"
                      style={{ paddingTop: '6px', paddingBottom: '6px' }}
                    >
                      Procedura completata, benvenuto in{' '}
                      {this.props.theme.nomeBrand}.
                    </Typography>
                  ) : (
                    <FormAccettazioneEsercizio
                      record={this.state.record}
                      handleSubmit={this.handleSubmit}
                      handleCheck={this.handleCheck}
                      saveMessageVisible={this.state.saveMessageVisible}
                    />
                  )}
                </div>
              )
            )}
          </div>
        </Grid>
      </div>
    );
  }
}

AccettaEsercizioCommerciale.propTypes = {
  activationKey: PropTypes.string.isRequired,
  theme: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(AccettaEsercizioCommerciale);
